import styled from "styled-components";

export const PaymentErrorWrapper = styled.div<{
    transparent?: boolean
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${p => p.mobile ? "95vw" : "min(90vw, 1152px)"};
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.transparent ? "transparent" : p.theme.sendGift.background};
    /* box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05); */
    border-radius: 8px;
    text-align: center;
`

export const PaymentErrorOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const ErrorTitle = styled.div<{
    mobile?: boolean
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "20px" : "43px"};
    font-weight: 600;
    line-height: ${p => p.mobile ? "34px" : "51px"};
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: ${p => p.mobile ? "0" : "16px"} ;
    color: ${p => p.theme.sendGift.text};
`

export const ErrorInfo = styled.div`
    width: 100%;
    max-width: 570px;
    max-height: 290px;
    padding: 24px;
    background-color: ${p => p.theme.sendGift.white};
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

export const CardFinalInfo = styled.div`
    display: flex;
    width: 100%;
`

export const FinalCard = styled.img<{
    mobile?: boolean
}>`
    max-height: 150px;
    max-width: 150px;
    object-fit: contain;
    object-position: top;
    margin-right: ${p => p.mobile ? "0" : "24px"};;
    margin-bottom: ${p => p.mobile ? "24px" : "0"};
`

export const FinalGiftText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 16px;
    color: ${p => p.theme.sendGift.text}
`

export const ErrorText = styled.div<{
    mobile?: boolean
    mb?: number
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "13px" : "17px"};
    font-weight: 400;
    line-height: ${p => p.mobile ? "18px" : "22px"};
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.sendGift.text73};
    margin-bottom: ${p => p?.mb !== undefined ? p.mb : 32}px;
    margin-top: ${p => p.mobile ? "12px" : "0px"};
    max-width: 400px;

    //styleName: 320px/Small Text (Regular);
`

export const ButtonTypography = styled.div<{fs?: number, fw?: number, lh?: number}>`
    font-family: Inter;
    font-size: ${p => p.fs || 17}px;
    font-weight: ${p => p.fw || 600};
    line-height: ${p => p.lh || 22};
`import styled from "styled-components";

export const PaymentErrorWrapper = styled.div<{
    transparent?: boolean
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${p => p.mobile ? "95vw" : "min(90vw, 1152px)"};
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.transparent ? "transparent" : p.theme.sendGift.background};
    /* box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05); */
    border-radius: 8px;
    text-align: center;
`

export const PaymentErrorOuterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

export const ErrorTitle = styled.div<{
    mobile?: boolean
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "20px" : "43px"};
    font-weight: 600;
    line-height: ${p => p.mobile ? "34px" : "51px"};
    letter-spacing: -0.02em;
    text-align: center;
    margin-bottom: ${p => p.mobile ? "0" : "16px"} ;
    color: ${p => p.theme.sendGift.text};
`

export const ErrorInfo = styled.div`
    width: 100%;
    max-width: 570px;
    max-height: 290px;
    padding: 24px;
    background-color: ${p => p.theme.sendGift.white};
    margin-bottom: 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`

export const CardFinalInfo = styled.div`
    display: flex;
    width: 100%;
`

export const FinalCard = styled.img<{
    mobile?: boolean
}>`
    max-height: 150px;
    max-width: 150px;
    object-fit: contain;
    object-position: top;
    margin-right: ${p => p.mobile ? "0" : "24px"};;
    margin-bottom: ${p => p.mobile ? "24px" : "0"};
`

export const FinalGiftText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 16px;
    color: ${p => p.theme.sendGift.text}
`

export const ErrorText = styled.div<{
    mobile?: boolean
    mb?: number
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "13px" : "17px"};
    font-weight: 400;
    line-height: ${p => p.mobile ? "18px" : "22px"};
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.sendGift.text73};
    margin-bottom: ${p => p?.mb !== undefined ? p.mb : 32}px;
    margin-top: ${p => p.mobile ? "12px" : "0px"};
    max-width: 400px;

    //styleName: 320px/Small Text (Regular);
`

export const ButtonTypography = styled.div<{fs?: number, fw?: number, lh?: number}>`
    font-family: Inter;
    font-size: ${p => p.fs || 17}px;
    font-weight: ${p => p.fw || 600};
    line-height: ${p => p.lh || 22};
`